import { Container, Card, Button, Field, Input, Select } from '../../components/ui';
import MedicoHeader from './MedicoHeader';
import TarjetaFranja from './TarjetaFranja';
import './Medico.css';

const FRANJAS = [
  { id: 1, dia: 'Lunes', rango: '09:00 – 13:00', detalle: 'Sede Centro · turnos cada 30 min' },
  { id: 2, dia: 'Miércoles', rango: '14:00 – 18:00', detalle: 'Sede Norte · turnos cada 20 min' },
  { id: 3, dia: 'Viernes', rango: '09:00 – 12:00', detalle: 'Sede Centro · turnos cada 30 min' },
];

export default function MedicoDisponibilidad() {
  return (
    <Container>
      <MedicoHeader titulo="Mi disponibilidad" />

      <div className="medico-cols" style={{ marginTop: 'var(--space-5)' }}>
        <section aria-labelledby="lista">
          <h2 id="lista">Franjas configuradas</h2>
          <div className="medico-list">
            {FRANJAS.map((f) => <TarjetaFranja key={f.id} franja={f} />)}
          </div>
        </section>

        <section aria-labelledby="form">
          <h2 id="form">Agregar disponibilidad</h2>
          <Card as="form" onSubmit={(e) => e.preventDefault()}>
            <Field label="Día de la semana" htmlFor="dia">
              <Select id="dia">
                <option>Lunes</option><option>Martes</option><option>Miércoles</option>
                <option>Jueves</option><option>Viernes</option><option>Sábado</option>
              </Select>
            </Field>
            <div className="medico-two-fields">
              <Field label="Desde" htmlFor="desde"><Input id="desde" type="time" defaultValue="09:00" /></Field>
              <Field label="Hasta" htmlFor="hasta"><Input id="hasta" type="time" defaultValue="13:00" /></Field>
            </div>
            <Field label="Sede" htmlFor="sede">
              <Select id="sede"><option>Sede Centro</option><option>Sede Norte</option><option>Sede Oeste</option></Select>
            </Field>
            <Field label="Duración del turno (min)" htmlFor="dur">
              <Input id="dur" type="number" defaultValue={30} min={10} step={5} />
            </Field>
            <Button type="submit" block>Guardar franja</Button>
          </Card>
        </section>
      </div>
    </Container>
  );
}